import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setCredentials } from '../store/slices/authSlice';
import { fetchPermissions } from '../store/slices/permissionsSlice';

const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const initializeAuth = async () => {
      // Check if there are stored tokens in localStorage
      const accessToken = localStorage.getItem('access_token');
      const refreshToken = localStorage.getItem('refresh_token');

      // If we're on the login page and tokens exist, clear them first
      // This prevents auto-authentication when user explicitly visits login
      if (location.pathname === '/login' && accessToken && refreshToken) {
        // Clear tokens if explicitly on login page
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        return;
      }

      // If both tokens exist, restore authentication state (regardless of current page)
      if (accessToken && refreshToken) {
        dispatch(setCredentials({
          accessToken,
          refreshToken,
        }));

        // Fetch permissions in background (don't wait for it to prevent white screen)
        dispatch(fetchPermissions()).catch(error => {
          console.error('Failed to fetch permissions on app initialization:', error);
        });
      }
    };

    initializeAuth();
  }, [dispatch, location.pathname]);

  return children;
};

export default AuthInitializer; 